import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 4v8","key":"svg-0"}],["path",{"d":"M16 4.5v7","key":"svg-1"}],["path",{"d":"M12 5v16","key":"svg-2"}],["path",{"d":"M8 5.5v5","key":"svg-3"}],["path",{"d":"M4 6v4","key":"svg-4"}],["path",{"d":"M20 8h-16","key":"svg-5"}]]

const IconAntenna = createReactComponent('outline', 'antenna', 'Antenna', __iconNode);

export default IconAntenna;